export default "__VITE_ASSET__DNxoEqKG__"